module.exports = __webpack_public_path__ + "img/ht.39ca71d2.svg";